const LOCAL_DOMAINS = ["localhost", "127.0.0.1", "192.168.1.119"];

function getURLs(): [string, string] {
    if (!LOCAL_DOMAINS.includes(window.location.hostname)) {
        return ["https://urdupub.com/app/", "https://api.urdupub.com/"];
    }

    return ["http://localhost:3901/app/", "http://localhost:3901/"];
}

const [SITE_URL, API_URL] = getURLs();
export { SITE_URL, API_URL };

export const API_VERSION = "v1";
export const API_BASE_URL = `${API_URL}${API_VERSION}`;

export const UD_EDITOR = "EDITOR";
export const UD_AUTHOR = "AUTHOR";
export const UD_REVIEWER = "REVIEWER";
export const UD_READER = "READER";

export const PAGE_EDITOR = "pages/EDITOR";
